import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { EurotaxRequest, EurotaxRequestType, EurotaxValuation } from '../../../domain/eurotax.domain';
import { VehicleType } from '../../../domain/product.domain';
import { GenericService } from './generic.service';
import { UtilsService } from './utils.service';


@Injectable()
export class EurotaxService extends GenericService {
    constructor(private store: Store,
                private http: HttpClient) {
        super(store);
    }

    getCategory() {
        return this.getList({
            type: EurotaxRequestType.CATEGORY
        });
    }

    getMakes(categoryId, year) {
        return this.getList({
            type: EurotaxRequestType.MAKE,
            categoryId,
            year
        });
    }

    getModels(categoryId, year, makeId) {
        return this.getList({
            type: EurotaxRequestType.MODEL,
            categoryId,
            year,
            makeId
        });
    }

    getBodyTypes(categoryId, year, makeId, modelId) {
        return this.getList({
            type: EurotaxRequestType.BODY,
            categoryId,
            year,
            makeId,
            modelId
        });
    }

    getDoors(categoryId, year, makeId, modelId, bodyType) {
        return this.getList({
            type: EurotaxRequestType.DOORS,
            categoryId,
            year,
            makeId,
            modelId,
            bodyType
        });
    }

    getFuelTypes(categoryId, year, makeId, modelId, bodyType, doorCount) {
        return this.getList({
            type: EurotaxRequestType.FUEL,
            categoryId,
            year,
            makeId,
            modelId,
            bodyType,
            doorCount
        });
    }

    getCapacities(categoryId, year, makeId, modelId, bodyType, doorCount, fuelType) {
        return this.getList({
            type: EurotaxRequestType.CAPACITY,
            categoryId,
            year,
            makeId,
            modelId,
            bodyType,
            doorCount,
            fuelType
        });
    }

    getGearBoxTypes(categoryId, year, makeId, modelId, bodyType, doorCount, fuelType, capacity) {
        return this.getList({
            type: EurotaxRequestType.GEARBOX,
            categoryId,
            year,
            makeId,
            modelId,
            bodyType,
            doorCount,
            fuelType,
            capacity
        });
    }

    getVersions(categoryId, year, makeId, modelId, bodyType, doorCount, fuelType, capacity, gearBoxType) {
        return this.getList({
            type: EurotaxRequestType.TYPE,
            categoryId,
            year,
            makeId,
            modelId,
            bodyType,
            doorCount,
            fuelType,
            capacity,
            gearBoxType
        });
    }


    private getList(request: Partial<EurotaxRequest>) {
        const params = UtilsService.buildQueryParams(request);
        return this.http.get<VehicleType[]>(`/api/secured/eurotax`, {params});
    }


    getValue(typeId: number, firstRegistrationDate: string, mileage: number) {
        const params = UtilsService.buildQueryParams({typeId, firstRegistrationDate, mileage});
        return this.http.get<EurotaxValuation>(`/api/secured/eurotax/valuation`, {params});
    }
}
